import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.open(); // open() will now redirect instead of opening the drawer
    }
  };

  open() {
    // 🚀 Redirect to cart page instead of showing the drawer
    window.location.href = '/cart';
    return;

    // If you ever want to restore the drawer, comment out the two lines above
    // and uncomment the original code below:
    // this.showDialog();
    //
    // customElements.whenDefined('shopify-payment-terms').then(() => {
    //   const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
    //   const cta = installmentsContent?.querySelector('#shopify-installments-cta');
    //   cta?.addEventListener('click', this.closeDialog, { once: true });
    // });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
